module.exports = __webpack_public_path__ + "assets/lineto-circular-pro-black.be068367f479bc6b318d0e33456e397c.woff2";